import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface F118 {
  f118_01: string;        // 等級代號 (PK, max 2 chars)
  f118_11: string;        // 等級說明
  f118_91: string;        // 建立人員
  f118_92: string | null; // 建立日期
  f118_93: string;        // 修改人員
}

export interface CreateRequest {
  f118_01: string;
  f118_11: string;
}

export interface UpdateRequest {
  f118_11: string;
}

export interface ListResponse {
  data: F118[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const productGradeApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/product-grade', { params });
    return res.data;
  },

  async get(code: string): Promise<F118> {
    const res = await apiClient.get(`/api/product-grade/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<F118> {
    const res = await apiClient.post('/api/product-grade', data);
    return res.data;
  },

  async update(code: string, data: UpdateRequest): Promise<F118> {
    const res = await apiClient.put(`/api/product-grade/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/product-grade/${encodeURIComponent(code)}`);
  },

  async copy(sourceCode: string, data: CreateRequest): Promise<F118> {
    const res = await apiClient.post(`/api/product-grade/${encodeURIComponent(sourceCode)}/copy`, data);
    return res.data;
  },
};
